import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-my",
  "use": "icon-my-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-my\">\n    <title>我的</title>\n    <g fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n        <circle cx=\"10\" cy=\"6.6\" r=\"3.2\" />\n        <path d=\"M4.2,16.6 C4.2,13.5 6.9,11.7 10,11.7 C13.1,11.7 15.8,13.5 15.8,16.6\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol